import {API_URL, apiPost} from '../api'

export const createLeagueApi = async data => {
    return await apiPost(API_URL, 'league', data)
}
